import { Autocomplete, TextField, Tooltip } from '@mui/material';

export default function AMESelect({ codes, value, onChange, disabled, ...props }) {
  const selected = codes.find((row) => row.code === value);
  const options = codes.filter((row) => (row.active && row.deletedBy == null) || row.code === value);
  return (
    <Tooltip title={<span style={{ whiteSpace: 'pre-wrap' }}>{selected?.description ?? ''}</span>}>
      <span style={{ display: 'block', width: '100%' }}>
        <Autocomplete {...props} fullWidth options={options} disabled={disabled}
          value={selected ?? (value ? { code: value } : null)}
          getOptionLabel={(option) => option.code}
          isOptionEqualToValue={(option, current) => option.code === current.code}
          onChange={(event, option) => onChange(event, option ? { value: option.code } : null)}
          renderInput={(inputProps) => <TextField {...inputProps} label="ÁME-kód" variant="standard" />} />
      </span>
    </Tooltip>
  );
}
